// Typ: FindCircleAreaFromRadiusTask
// Temat: Okrąg i koło → Elementy, długości i pola → Pole koła
// Wzór:  P = π r^2

import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import PiInput, { parsePiLikeInput, formatPiValueLatex } from "../../../../components/inputs/PiInput";

const DEC_TOL = 0.1; // akceptujemy liczby dziesiętne z dokładnością ±0.1

// ===== generator =====
export function generateTask() {
  const r = Math.floor(Math.random() * 9) + 2; // promień 2..10
  return {
    type: "FindCircleAreaFromRadiusTask",
    data: { r }
  };
}

// ===== render task =====
export function renderTask({ data }) {
  const { r } = data;
  return (
    <div style={{ marginTop: 16, marginBottom: 8 }}>
      Dany jest okrąg o promieniu <InlineMath math={`r=${r}`} />.
      Oblicz pole koła <InlineMath math={'P'} />.
    </div>
  );
}

// ===== input =====
export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <PiInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label={'P'}
      placeholder="np. 25π, 9/2π, π/2 lub 78.5 (±0.1)"
    />
  );
}

// ===== check =====
export function checkAnswer({ data }, userAnswer) {
  const { r } = data;
  const expected = Math.PI * r * r;

  const parsed =
    typeof userAnswer === "object" && userAnswer?.parsed != null
      ? userAnswer.parsed
      : parsePiLikeInput(typeof userAnswer === "object" ? userAnswer.raw : userAnswer);

  if (parsed == null || !Number.isFinite(parsed)) return false;
  return Math.abs(parsed - expected) <= DEC_TOL;
}

// ===== answer (dokładny zapis: P = k·π ) =====
export function renderAnswer({ data }) {
  const { r } = data;
  const k = r * r; // P = (r^2)π
  const exact = k === 1 ? "\\pi" : `${k} \\pi`;
  return (
    <div style={{ marginTop: 6 }}>
      <InlineMath math={`P = ${exact}`} />
    </div>
  );
}

// ===== explanation =====
export function renderExplanation({ data }) {
  const { r } = data;
  const k = r * r;
  const approx = (Math.PI * r * r).toFixed(2);
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <div><strong>Krok 1.</strong> Wzór na pole koła:</div>
      <BlockMath math={'P = \\pi r^{2}'} />

      <div><strong>Krok 2.</strong> Podstawiamy <InlineMath math={`r=${r}`} />:</div>
      <BlockMath math={`P = \\pi \\cdot ${r}^{2} = ${k}\\,\\pi`} />

      <div><strong>Krok 3.</strong> (Opcjonalnie) Przybliżenie:</div>
      <BlockMath math={`P \\approx ${approx}`} />
    </div>
  );
}

// ===== user answer (jak Odpowiedź — P = … ) =====
export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "object" ? userAnswer.raw : userAnswer;
  if (!raw || typeof raw !== "string" || raw.trim() === "") {
    return <i>(brak odpowiedzi)</i>;
  }
  const latexValue = formatPiValueLatex(raw);
  return (
    <div style={{ marginTop: 6 }}>
      <InlineMath math={`P = ${latexValue || ""}`} />
    </div>
  );
}
